import normal from './normal.json';

export default { normal };
